export const QUICK_LINKS = [
  {
    label: 'Turn In Orders',
    icon: 'mdi-clipboard-text-outline',
    routeName: 'retailer-turn-in-orders'
  },
  {
    label: 'Purchase History',
    icon: 'mdi-history',
    routeName: 'purchase-orders-history'
  },
  {
    label: 'Transactions',
    icon: 'mdi-swap-horizontal',
    routeName: 'transactions'
  },
  {
    label: 'Bulk Product Upload',
    icon: 'mdi-cloud-upload-outline',
    routeName: 'products-bulk-upload'
  }
]

export const QUICK_LINK_MAIN_ROUTES = [
  'dashboard',
  'purchase-orders',
  'order-queries',
  'credit-returns',
  'data-maintenance',
  'reports',
  'retailer-turn-in-orders',
  'purchase-orders-history',
  'transactions'
]

export const isQuickLinksMainPage = (routeName) =>
  QUICK_LINK_MAIN_ROUTES.includes(routeName)
